<div class="main-container">
    <div class="polar-title">
        <span>
            {{polarTitle}}
        </span>
    </div>
    <!-- <ng-container *ngIf="chart"> -->

    <!-- <div [hidden]="!chart"> -->
    <canvas class="my-4 w-100" id="polarArea" width="900" height="380">{{chart}}</canvas>
    <!-- </div> -->
    <!-- </ng-container> -->
</div>